module.exports = {"title":"手機及裝置"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/mobileDevice/zh-hk.json
// module id = 3Gp9
// module chunks = 1